<span *ngIf="model.is10FedUser"> {{createdByName}} </span>
<span *ngIf="!model.is10FedUser">
    <a [routerLink]="[model.createdByLink]" [queryParams]="model.createdByParams">
        {{createdByName}} </a> </span>